import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, Container, FormControlLabel, Stack, Switch, Typography } from "@mui/material";
import apis from "services";
import { toast } from "react-toastify";
import AdminNewSidebar from "components/admin/AdminNewSidebar";
import { Header } from "components";

const WorldCupBonus = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [active, setActive] = useState(false);
  const [bonus, setBonus] = useState(null);

  const fetchState = async () => {
    setLoading(true);
    try {
      const res = await apis.getWorldCupBonusState();
      const currentBonus = res?.data?.bonus;
      setBonus(currentBonus || null);
      setActive(!!currentBonus?.active);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchState();
  }, []);

  const handleToggle = async (event) => {
    const nextValue = event.target.checked;
    setSaving(true);
    try {
      const res = await apis.toggleWorldCupBonus({ active: nextValue });
      const currentBonus = res?.data?.bonus;
      setBonus(currentBonus || null);
      setActive(!!currentBonus?.active);
      toast.success(res?.data?.message || (nextValue ? "World Cup bonus enabled" : "World Cup bonus disabled"));
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || "Unable to update bonus");
      await fetchState();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box className="dashboard-main">
      <AdminNewSidebar />
      <div className="dashboard-section-main">
        <Box component="main" sx={{ flexGrow: 1, height: "100vh", overflow: "auto" }} className="custom-scroll">
          <Header />
          {loading ? (
            <div className="loader-container">
              <div className="loader" />
            </div>
          ) : (
            <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }} className="mainContainerComp">
              <Stack spacing={3}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 700, textTransform: "uppercase" }}>
                    Enable FIFA WORLD CUP BONUS
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1, color: "text.secondary" }}>
                    Turn the promotion on for a match window. The system automatically expires it after 24 hours.
                  </Typography>
                </Box>

                <Card sx={{ borderRadius: 3 }}>
                  <CardContent>
                    <Stack spacing={2}>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={active}
                            onChange={handleToggle}
                            disabled={saving}
                          />
                        }
                        label={active ? "Enabled" : "Disabled"}
                      />

                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        Bonus percent: {bonus?.bonusPercent ?? 10}%
                      </Typography>

                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        {bonus?.expiresAt
                          ? `Expires at: ${new Date(bonus.expiresAt).toLocaleString()}`
                          : "No active expiry yet."}
                      </Typography>

                      <Typography variant="body2" sx={{ color: "text.secondary" }}>
                        If Mexico scores 5 goals in 90 minutes, the bonus still counts as one active promotion window. Extra goals do not stack. If you want a new promotion window later, toggle it on again.
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Stack>
            </Container>
          )}
        </Box>
      </div>
    </Box>
  );
};

export default WorldCupBonus;
